import { Td } from '../../summary/components/Td.js';
import { Tr } from '../../summary/components/Tr.js';

export const SummaryTableBoldDivider = () => (
  <Tr height="2px !important" width="100%">
    <Td backgroundColor="surfaceAccent9" height={'2px'} colSpan={8} />
  </Tr>
);
